import { getAnalytics, isSupported, logEvent } from 'firebase/analytics';
import { EventInformation, EventType } from 'analytics/models';
import appDetails from '../../package.json';

export const trackEvent = async <T extends EventType>(
  event: T,
  eventInformation: EventInformation[T],
): Promise<void> => {
  let analyticsIsSupported = false;

  try {
    analyticsIsSupported = await isSupported();
  } catch {}

  if (analyticsIsSupported) {
    const analytics = getAnalytics();

    logEvent(
      analytics,
      event as string, // satisfy ts
      {
        ...eventInformation,
        app_version: appDetails.version,
      },
    );
  }
};
